export default __webpack_public_path__ + "static/media/SCDream-ExtraBold.a8d826f4.otf";